/*
 *
 * ProtectNetworksModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import ProtectNetworksModal from './ProtectNetworksModalContainer'

export default ProtectNetworksModal
